/* Casequmi Theme — theme.js (vanilla, no dependencies) */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var R = window.routes || { root: '/', cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change' };
  var S = window.themeSettings || {};

  /* ---------- Money ---------- */
  function money(cents) {
    var f = S.moneyFormat || '{{amount}}';
    var v = Number(cents) / 100;
    function fmt(n, d, ts, ds) {
      var p = n.toFixed(d).split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts);
      return d ? p.join(ds) : p[0];
    }
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      switch (k) {
        case 'amount_no_decimals': return fmt(v, 0, ',', '.');
        case 'amount_with_comma_separator': return fmt(v, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(v, 0, '.', ',');
        case 'amount_with_space_separator': return fmt(v, 2, ' ', ',');
        case 'amount_with_apostrophe_separator': return fmt(v, 2, "'", '.');
        default: return fmt(v, 2, ',', '.');
      }
    });
  }
  window.casequmiMoney = money;

  /* ---------- Drawers (menu, cart, search, filters) ---------- */
  var lastFocus = null;
  function openPanel(el) {
    if (!el) return;
    lastFocus = document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('no-scroll');
    var f = el.querySelector('input[type=search], .drawer__close, button');
    if (f) setTimeout(function () { f.focus(); }, 60);
  }
  function closePanel(el) {
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    if (!$('.drawer.is-open, .search-modal.is-open')) document.documentElement.classList.remove('no-scroll');
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var op = e.target.closest('[data-open]');
    if (op) {
      var target = document.getElementById(op.getAttribute('data-open'));
      if (target) { e.preventDefault(); openPanel(target); }
      return;
    }
    var cl = e.target.closest('[data-close]');
    if (cl) { e.preventDefault(); closePanel(cl.closest('.drawer, .search-modal')); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') $$('.drawer.is-open, .search-modal.is-open').forEach(closePanel);
  });

  /* ---------- Header scroll state ---------- */
  var hw = $('.header-wrap');
  if (hw) {
    var onScroll = function () { hw.classList.toggle('is-scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  }

  /* ---------- Announcement rotator ---------- */
  $$('[data-announcement]').forEach(function (bar) {
    var items = $$('.announcement__item', bar);
    if (items.length < 2) return;
    var i = 0, speed = (parseInt(bar.getAttribute('data-speed'), 10) || 4) * 1000;
    setInterval(function () {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, speed);
  });

  /* ---------- Generic horizontal sliders ---------- */
  function initScroller(wrap) {
    var track = $('[data-track]', wrap);
    if (!track) return;
    $$('[data-prev],[data-next]', wrap).forEach(function (b) {
      b.addEventListener('click', function () {
        var dir = b.hasAttribute('data-next') ? 1 : -1;
        track.scrollBy({ left: dir * track.clientWidth * 0.85, behavior: 'smooth' });
      });
    });
  }
  $$('[data-scroller]').forEach(initScroller);

  /* ---------- Hero slider ---------- */
  $$('[data-hero]').forEach(function (hero) {
    var track = $('[data-track]', hero);
    var slides = $$('.hero__slide', hero);
    var dots = $$('.hero__dot', hero);
    if (!track || slides.length < 2) return;
    var idx = 0, timer = null, delay = (parseInt(hero.getAttribute('data-autoplay'), 10) || 0) * 1000;
    function go(n) {
      idx = (n + slides.length) % slides.length;
      track.scrollTo({ left: slides[idx].offsetLeft - track.offsetLeft, behavior: 'smooth' });
    }
    function sync() {
      var n = Math.round(track.scrollLeft / track.clientWidth);
      idx = n;
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === n); d.setAttribute('aria-current', k === n ? 'true' : 'false'); });
    }
    track.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
    dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); restart(); }); });
    var p = $('[data-prev]', hero), nx = $('[data-next]', hero);
    if (p) p.addEventListener('click', function () { go(idx - 1); restart(); });
    if (nx) nx.addEventListener('click', function () { go(idx + 1); restart(); });
    function restart() { if (!delay) return; clearInterval(timer); timer = setInterval(function () { go(idx + 1); }, delay); }
    hero.addEventListener('mouseenter', function () { clearInterval(timer); });
    hero.addEventListener('mouseleave', restart);
    restart();
  });

  /* ---------- Tabs ---------- */
  $$('[data-tabs]').forEach(function (wrap) {
    var btns = $$('[role=tab]', wrap);
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        btns.forEach(function (x) {
          var on = x === b;
          x.setAttribute('aria-selected', on ? 'true' : 'false');
          x.tabIndex = on ? 0 : -1;
          var panel = document.getElementById(x.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
      });
      b.addEventListener('keydown', function (e) {
        var i = btns.indexOf(b);
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          var n = btns[(i + (e.key === 'ArrowRight' ? 1 : -1) + btns.length) % btns.length];
          n.focus(); n.click();
        }
      });
    });
  });

  /* ---------- SEO text toggle ---------- */
  $$('[data-seo-toggle]').forEach(function (b) {
    b.addEventListener('click', function () {
      var w = b.closest('.seo-text');
      var open = w.classList.toggle('is-open');
      b.textContent = open ? b.getAttribute('data-less') : b.getAttribute('data-more');
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  /* ---------- Reveal on scroll ---------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    $$('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    $$('.reveal').forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ---------- Cart ---------- */
  function sectionsUrl(ids) {
    var root = R.root || '/';
    return root + (root.slice(-1) === '/' ? '' : '/') + '?sections=' + ids;
  }
  function setCount(n) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = n; el.setAttribute('data-count', n); });
  }
  function refreshCart() {
    return fetch(sectionsUrl('cart-drawer'), { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data && data['cart-drawer'];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById('CartDrawerInner');
        var cur = document.getElementById('CartDrawerInner');
        if (fresh && cur) { cur.replaceWith(fresh); setCount(fresh.getAttribute('data-count') || 0); }
      });
  }
  window.casequmiRefreshCart = refreshCart;

  function showFormError(form, msg) {
    var box = $('[data-form-error]', form) || $('[data-form-error]', form.closest('[data-product]') || document.body);
    if (box) { box.textContent = msg; box.hidden = false; setTimeout(function () { box.hidden = true; }, 5000); }
    else alert(msg);
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-type="add-to-cart-form"]');
    if (!form || S.cartType === 'page' || !document.getElementById('CartDrawer')) return;
    e.preventDefault();
    var btn = e.submitter || $('[type=submit]', form);
    if (btn) btn.classList.add('is-loading');
    fetch(R.cartAdd + '.js', { method: 'POST', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: new FormData(form), credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (j && j.status) { showFormError(form, j.description || j.message || 'Ürün sepete eklenemedi.'); return; }
        return refreshCart().then(function () { openPanel(document.getElementById('CartDrawer')); });
      })
      .catch(function () { form.submit(); })
      .finally(function () { if (btn) btn.classList.remove('is-loading'); });
  });

  function changeLine(line, qty) {
    var drawer = document.getElementById('CartDrawer');
    if (drawer) drawer.classList.add('is-busy');
    return fetch(R.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ line: Number(line), quantity: Number(qty) }), credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (j && j.status) { alert(j.description || j.message); }
        if (document.body.classList.contains('template-cart')) { window.location.reload(); return; }
        return refreshCart();
      })
      .finally(function () { if (drawer) drawer.classList.remove('is-busy'); });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-line-qty]');
    if (b) {
      e.preventDefault();
      changeLine(b.getAttribute('data-line'), b.getAttribute('data-line-qty'));
    }
  });
  document.addEventListener('change', function (e) {
    var inp = e.target.closest('[data-line-input]');
    if (inp) changeLine(inp.getAttribute('data-line'), Math.max(0, parseInt(inp.value, 10) || 0));
  });

  /* ---------- Quantity steppers (product page) ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty-step]');
    if (!b) return;
    var inp = $('input', b.closest('.qty'));
    if (!inp || inp.hasAttribute('data-line-input')) return;
    var v = Math.max(1, (parseInt(inp.value, 10) || 1) + Number(b.getAttribute('data-qty-step')));
    inp.value = v;
  });

  /* ---------- Product gallery (works on its own) ---------- */
  function slideTo(main, slide) {
    if (!main || !slide) return;
    var left = slide.getBoundingClientRect().left - main.getBoundingClientRect().left + main.scrollLeft;
    main.scrollTo({ left: left, behavior: 'smooth' });
  }
  $$('.gallery').forEach(function (gal) {
    var main = $('.gallery__main', gal);
    var slides = $$('.gallery__slide', gal);
    var thumbs = $$('.gallery__thumb', gal);
    var counter = $('[data-gallery-count]', gal);
    if (!main) return;
    function setActive(n) {
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === n); });
      if (counter) counter.textContent = (n + 1) + ' / ' + slides.length;
      var at = thumbs[n];
      if (at && at.parentNode && at.parentNode.scrollTo) {
        var tp = at.parentNode;
        tp.scrollTo({ left: at.offsetLeft - tp.clientWidth / 2 + at.clientWidth / 2, top: at.offsetTop - tp.clientHeight / 2 + at.clientHeight / 2, behavior: 'smooth' });
      }
    }
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function (e) { e.preventDefault(); slideTo(main, slides[i]); setActive(i); });
    });
    var raf = null;
    main.addEventListener('scroll', function () {
      if (raf) return;
      raf = window.requestAnimationFrame(function () {
        raf = null;
        var n = Math.round(main.scrollLeft / Math.max(1, main.clientWidth));
        n = Math.max(0, Math.min(slides.length - 1, n));
        setActive(n);
      });
    }, { passive: true });
    gal._goToMedia = function (id) {
      var i = slides.findIndex(function (s) { return s.getAttribute('data-media-id') === String(id); });
      if (i > -1) { slideTo(main, slides[i]); setActive(i); }
    };
  });

  /* ---------- Product page variants ---------- */
  $$('[data-product]').forEach(function (root) {
    var dataEl = $('[data-variants]', root);
    var form = $('form[data-type="add-to-cart-form"]', root);
    if (!dataEl || !form) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }
    var idInput = $('[name=id]', form);
    var groups = $$('[data-option-index]', root);
    var addBtn = $('[data-add-btn]', root);
    var priceBox = $('[data-price]', root);
    var stockBox = $('[data-stock]', root);
    var sticky = $('[data-sticky-atc]');
    var gallery = $('.gallery', root);
    var labels = { add: addBtn ? addBtn.getAttribute('data-label-add') : 'Sepete Ekle', sold: addBtn ? addBtn.getAttribute('data-label-sold') : 'Tükendi', na: 'Bu seçenek mevcut değil' };

    function valueOf(g) {
      var sel = $('select', g);
      if (sel) return sel.value;
      var c = $('input:checked', g);
      return c ? c.value : null;
    }
    function selected() { return groups.map(valueOf); }
    function find(sel) { return variants.find(function (v) { return v.options.every(function (o, i) { return o === sel[i]; }); }); }
    function isOk(test) { return variants.some(function (v) { return v.available && v.options.every(function (o, i) { return o === test[i]; }); }); }

    function markAvailability(sel) {
      groups.forEach(function (g, gi) {
        $$('input', g).forEach(function (inp) {
          var test = sel.slice(); test[gi] = inp.value;
          var lbl = inp.nextElementSibling;
          if (lbl) lbl.classList.toggle('is-unavailable', !isOk(test));
        });
        $$('select option', g).forEach(function (op) {
          var test = sel.slice(); test[gi] = op.value;
          var base = op.getAttribute('data-label') || op.textContent;
          op.setAttribute('data-label', base);
          op.textContent = isOk(test) ? base : base + ' (Tükendi)';
        });
        var out = $('[data-selected-value]', g);
        if (out) out.textContent = valueOf(g) || '';
      });
    }

    function renderPrice(v) {
      if (!priceBox || !v) return;
      var sale = v.compare_at_price && v.compare_at_price > v.price;
      var html = '<div class="price' + (sale ? ' price--sale' : '') + '"><span class="price__current">' + money(v.price) + '</span>';
      if (sale) {
        var pct = Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price);
        html += '<s class="price__compare">' + money(v.compare_at_price) + '</s><span class="price__save">%' + pct + ' indirim</span>';
      }
      priceBox.innerHTML = html + '</div>';
      $$('[data-sticky-price]').forEach(function (el) { el.textContent = money(v.price); });
    }

    function renderStock(v) {
      if (!stockBox) return;
      var cls = 'stock', txt = 'Stokta';
      if (!v) { cls += ' stock--out'; txt = labels.na; }
      else if (!v.available) { cls += ' stock--out'; txt = 'Tükendi'; }
      else if (v.inventory_management && v.inventory_quantity > 0 && v.inventory_quantity <= 5) { cls += ' stock--low'; txt = 'Son ' + v.inventory_quantity + ' ürün!'; }
      stockBox.className = cls;
      stockBox.innerHTML = '<i></i>' + txt;
    }

    function update() {
      var sel = selected();
      var v = find(sel);
      markAvailability(sel);
      [addBtn, $('[data-sticky-add]')].forEach(function (b) {
        if (!b) return;
        if (!v) { b.disabled = true; b.textContent = labels.na; }
        else if (!v.available) { b.disabled = true; b.textContent = labels.sold; }
        else { b.disabled = false; b.textContent = labels.add; }
      });
      if (v) {
        idInput.value = v.id;
        renderPrice(v);
        if (v.featured_media && gallery && gallery._goToMedia) gallery._goToMedia(v.featured_media.id);
        if (window.history.replaceState) {
          var u = new URL(window.location.href); u.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', u.toString());
        }
        $$('[data-variant-title]').forEach(function (el) { el.textContent = v.title === 'Default Title' ? '' : v.title; });
      }
      renderStock(v);
    }
    root.addEventListener('change', function (e) { if (e.target.closest('[data-option-index]')) update(); });
    markAvailability(selected());

    /* Sticky add to cart */
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        var e = en[0];
        sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(addBtn);
      var sAdd = $('[data-sticky-add]', sticky);
      if (sAdd) sAdd.addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit(addBtn); else addBtn.click();
      });
    }
  });

  /* ---------- Collection filters ---------- */
  $$('[data-filter-form]').forEach(function (form) {
    var t;
    form.addEventListener('change', function (e) {
      if (e.target.matches('[data-price-input]')) return;
      submitFilters(form);
    });
    form.addEventListener('input', function (e) {
      if (!e.target.matches('[data-price-input]')) return;
      clearTimeout(t); t = setTimeout(function () { submitFilters(form); }, 900);
    });
  });
  function submitFilters(form) {
    var fd = new FormData(form);
    var params = new URLSearchParams();
    fd.forEach(function (v, k) { if (v !== '') params.append(k, v); });
    var sort = $('[data-sort]');
    if (sort && sort.value && !params.has('sort_by')) params.set('sort_by', sort.value);
    var q = new URL(window.location.href).searchParams.get('q');
    if (q && !params.has('q')) params.set('q', q);
    var type = new URL(window.location.href).searchParams.get('type');
    if (type && !params.has('type')) params.set('type', type);
    window.location.search = params.toString();
  }
  $$('[data-sort]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', sel.value);
      u.searchParams.delete('page');
      window.location.href = u.toString();
    });
  });

  /* ---------- Newsletter success scroll ---------- */
  if (window.location.search.indexOf('customer_posted=true') > -1) {
    var nf = $('[data-newsletter-ok]');
    if (nf) nf.scrollIntoView({ block: 'center' });
  }
})();
